import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { DocumentDetailClassAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';

export type StatusCellRenderParams = CellRendererParams<DocumentDetailClassAttributes>

/**
 * Material Cell Renderer
 *
 * Renders a read-only mat-slide-toggle inside a grid cell.
 * Supports both boolean fields and numeric (e.g., statusId === 1).
 * 
 * columns:
 * - statusId
 * 
 * @example
 * ```typescript
 * {
 *   field: 'statusId',
 *   headerName: 'Estado',
 *   cellRenderer: StatusCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */

@Component({
  selector: 'app-status-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatSlideToggleModule],
  template: `
    <mat-slide-toggle class="custom-slide-toggle primary"
        [checked]="checked" [color]="'success'"
        (change)="onToggleChange($event.checked)">
    </mat-slide-toggle>
  `,
})

export class StatusCellRendererComponent implements CellRenderer<DocumentDetailClassAttributes> {
  @Input() params!: StatusCellRenderParams;
  checked: boolean = false;

  ngOnInit() {
    const field = this.params.colDef?.field;
    const data = this.params.data;

    if (field && data) {
      const value = data[field];
      this.checked = typeof value === 'boolean' ? value : value === StatusEnum.ACTIVE;
    }
  }

  onToggleChange(checked: boolean) {
    this.checked = checked;
    const data = this.params.data;

    if (this.params.colDef?.cellRendererParams?.onStatusChange) {
      this.params.colDef.cellRendererParams.onStatusChange(checked, data);
    }
  }
}